// extracted by mini-css-extract-plugin
export default {"component":"IncodeCaptureComplete-module__component-uxPJ","statusText":"IncodeCaptureComplete-module__statusText-vbUi"};